module.exports = __webpack_public_path__ + "static/media/404.9e6a0c7f.png";